import apiClient from "config/api";

const getProfile = async () => {
  return await apiClient.get("/admin/user/get-profile");
};

const updateProfile = async (data) => {
  return await apiClient.patch("/admin/user/update-profile", data);
};

const changePassword = async (body) => {
  return await apiClient.put(`/admin/user/change-password`, body);
};

export { getProfile, updateProfile, changePassword };
